// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"195f25b5","952":"06c08e31"}[chunkId] + ".chunk.js";
};